// Shipping Time Countdown
if (!customElements.get("shipping-time")) {
  customElements.define(
    "shipping-time",
    class ShippingTimeUpdate extends HTMLElement {
      constructor() {
        super();
        this.fetchVariantInfo(this.dataset.variantId);
      }

      fetchVariantInfo(variantId) {
        const gid = "gid://shopify/ProductVariant/" + variantId;
        const query = `
            query getProductVariant($id: ID!){
              node(id: $id) {
                ... on ProductVariant {
                  title
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          `;

        fetch("https://invelon.myshopify.com/api/2023-07/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token":
              "f53b1f4eaee961b267cfd4122d7699ae",
          },
          body: JSON.stringify({ query, variables: { id: gid } }),
        })
          .then(response => response.json())
          .then(data => {
            this.updateShippingText(data.data.node);
          })
          .catch(error => console.error(error));
      }

      updateShippingText() {
        const now = new Date();
        const day = now.getDay();
        let end;
        let diffInHours;
        let diffInMinutes;

        const shippingTimeTextElement =
          document.getElementById("shipping-time-text");
        const shippingTimeCountdownElement = document.getElementById(
          "shipping-time-countdown"
        );
        //set default shipping time
        shippingTimeTextElement.innerHTML = this.dataset.shippingTime;

        // annual leave date, or friday after 3pm, or saturday, or sunday
        if (
          isAnnualLeaveDate(now, this.dataset.annualLeave) ||
          (day == 5 && now.getHours() >= 15) ||
          day == 6 ||
          day == 0
        ) {
          shippingTimeTextElement.innerHTML =
            this.dataset.shippingTimeOutOfOffice;
          shippingTimeCountdownElement.innerHTML =
            this.dataset.shippingTimeToday;
          // monday to friday before 3pm
        } else if (day >= 1 && day <= 5 && now.getHours() < 15) {
          end = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            16,
            0,
            0,
            0
          );
        } else {
          end = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + 1,
            16,
            0,
            0,
            0
          );
          shippingTimeTextElement.innerHTML = this.dataset.shippingTimeTomorrow;
        }

        const timeleft = end.getTime() - now.getTime();

        diffInHours = Math.floor(timeleft / (1000 * 60 * 60));
        diffInMinutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));

        shippingTimeCountdownElement.innerHTML = `${diffInHours}HRS ${diffInMinutes}MIN`;
      }
    }
  );
}

/**
 * Formats a date to es-ES
 * @param {Date | number} date
 * @returns string
 */
const formatDate = date => new Intl.DateTimeFormat("es-ES").format(date);

/**
 * Compares a date against the annual leave dates and returns true if it's in the array
 * @param {Date | number} dateToCheck
 * @param {any} annualLeave
 * @returns boolean
 */
const isAnnualLeaveDate = (dateToCheck, annualLeave) => {
  const formattedDateToCheck = formatDate(dateToCheck);
  const parsedAnnualLeaveValue = JSON.parse(annualLeave);

  // the annual leave value is an array
  if (Array.isArray(parsedAnnualLeaveValue)) {
    const annualLeaveDates = parsedAnnualLeaveValue.map(date => new Date(date));
    const formattedAnnualLeaveDates = annualLeaveDates.map(date =>
      formatDate(date)
    );
    return formattedAnnualLeaveDates.includes(formattedDateToCheck);
  }
  // the annual leave value is a single date
  else if (typeof parsedAnnualLeaveValue === "string") {
    const annualLeaveDate = new Date(parsedAnnualLeaveValue);
    const formattedAnnualLeaveDate = formatDate(annualLeaveDate);
    return formattedAnnualLeaveDate === formattedDateToCheck;
  }
  // the annual leave value is something else
  else {
    return false;
  }
};
